var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { attrs: { "data-aos": "fade-left" } }, [
      _vm._v(_vm._s(_vm.$t("ac_cleaning.condition_of_service_section.title")))
    ]),
    _vm._v(" "),
    _c("p", {
      staticClass: "sub-text",
      attrs: { "data-aos": "fade-right" },
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("ac_cleaning.condition_of_service_section.subtitle")
        )
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46bd42b5", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46bd42b5","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acCleaningRe/TransparentPricing.vue
// module id = 1596
// module chunks = 0